import { BasePeerToPeerCampaignAction } from "./BasePeerToPeerCampaignAction";

import { FormButton } from "@/forms-design-system/FormButton/FormButton";
import { useTranslate } from "@/hooks/useTranslate";
import { ArrowDiagonalRight } from "@/icons/outlined";
type PeerToPeerRegisterCampaignActionProps = {
  onClick?: () => void;
};

export const PeerToPeerRegisterCampaignAction = ({ onClick }: PeerToPeerRegisterCampaignActionProps) => {
  const { t } = useTranslate();

  return (
    <BasePeerToPeerCampaignAction
      title={t("donationForm", "peerToPeer.title.registerAndFundraise")}
      description={t("donationForm", "peerToPeer.description.createCampaign")}
      slots={{
        button: (
          <FormButton variant="outline" endIcon={<ArrowDiagonalRight />} onClick={onClick}>
            {t("donationForm", "peerToPeer.button.registerAndFundraise")}
          </FormButton>
        ),
      }}
    />
  );
};
